const CONFIG = {
  selectedClass: "selected",
}

class NewCustomSelect extends HTMLElement {
  constructor() {
    // Always call super first in constructor
    super();

    this.productHandle = this.getAttribute("data-product-handle");
    this.getElement();
    this.addEventListeners();
  }

  getElement() {
    this.selectEl = this.querySelector(".js-select");
    this.optionEls = this.querySelectorAll(".js-option");
    this.selectValueEl = this.querySelector(".js-select-value");
    this.selectListEl = this.querySelector(".js-select-list");
    this.parentPersonalizer = this.selectEl.closest("new-personalizer");
    this.parentInnerEl = this.parentPersonalizer?.querySelector(".js-personalizer-inner");
  }

  addEventListeners() {
    this.selectValueEl?.addEventListener("click", this.handleSelectClick.bind(this));
    this.optionEls?.forEach((el) => {
      el.addEventListener("click", this.handleOptionClick.bind(this, el));
    });
  }

  handleSelectClick() {
    if (!this.selectEl?.classList.contains("open")) {
      const allSelects = document.querySelectorAll(".js-select");
      allSelects.forEach((select) => {
        if (select !== this.selectEl) {
          select.classList.remove("open");
        }
      })
    }
    this.selectEl?.classList.toggle("open");


    if (this.parentInnerEl) {
      if (this.selectEl.classList.contains("open")) {
        // this.parentInnerEl scroll to bottom
        this.parentInnerEl.scrollTop = this.parentInnerEl.scrollHeight;
        this.parentInnerEl.style.overflow = "hidden";
      } else {
        this.parentInnerEl.style.overflow = "auto";
      }
    }
  }

  handleOptionClick(item) {
    const name = item.dataset.name;
    const value = item.dataset.value;
    const thumbnail = item.dataset.icon;
    const variantId = item.dataset.variant;
    this.selectValueEl.querySelector('span').innerHTML = name;
    this.selectValueEl?.setAttribute("data-value", value);
    this.selectValueEl?.setAttribute("data-variant", variantId);
    const imgEl = this.selectValueEl.querySelector('img');
    if (imgEl) {
      if (thumbnail) {
        imgEl.src = thumbnail;
      } else {
        imgEl.src = '';
      }
    }
    this.selectEl?.classList.remove("open");
    item.classList.add(CONFIG.selectedClass);
    this.optionEls?.forEach((el) => {
      if (el !== item) {
        el.classList.remove(CONFIG.selectedClass);
      }
    });
    this.handleOptionSelected(item);
    if (this.parentInnerEl) {
      this.parentInnerEl.style.overflow = "auto";
    }
  }

  handleOptionSelected(item) {}
}

class NewExtraSelect extends NewCustomSelect {

  constructor() {
    super();

    this.changePreview = this.getAttribute("data-change-preview");
  }

  handleOptionSelected(item) {
    const value = item.dataset.value;
    document.dispatchEvent(new CustomEvent("extraSelected", {
      detail: {
        number: value,
        price: item.dataset.price,
      },
    }));

    if (this.changePreview) {
      document.dispatchEvent(new CustomEvent("changePreview", {
        detail: {
          number: value,
        },
      }));
    }
  }
}

customElements.define("new-extra-select", NewExtraSelect);

class NewExtraBirthstone extends NewCustomSelect {
  constructor() {
    // Always call super first in constructor
    super();

    this.newPersonalizer = this.closest(".js-personalizer");

    this.dataNumber = this.getAttribute("data-number");
    document.addEventListener("extraSelected", (e) => {
      const number = e.detail.number;
      if (this.dataNumber <= number) {
        this.style.display = "block";
        this.classList.add("js-validation");
      } else {
        this.style.display = "none";
        this.classList.remove("js-validation");
        // A stone that just went out of range must not stay in the cart
        // payload or on the order: forget its pick.
        this.clearPick();
      }
    });
  }

  // The property key of this stone ("Birthstone 2"), read from its options so
  // the placeholder row (which carries no key) can clear the right one.
  stoneKey() {
    const opt = this.querySelector(".js-extra-item[data-key]");
    return opt ? opt.dataset.key : null;
  }

  clearPick() {
    const placeholder = this.querySelector(".js-option:not(.js-extra-item)");
    const hadPick = !!this.querySelector(".js-extra-item.selected");
    this.optionEls?.forEach((el) => el.classList.remove("selected"));
    if (placeholder) {
      placeholder.classList.add("selected");
      const span = this.selectValueEl?.querySelector("span");
      if (span) span.innerHTML = placeholder.dataset.name || "";
      this.selectValueEl?.setAttribute("data-value", "");
      this.selectValueEl?.setAttribute("data-variant", "");
      const img = this.selectValueEl?.querySelector("img");
      if (img && placeholder.dataset.icon) img.src = placeholder.dataset.icon;
    }
    if (hadPick) this.handleOptionSelected(placeholder || { dataset: {} });
  }

  handleOptionSelected(item) {
    // The placeholder ("Select Birthstone") has no key: it means "no stone",
    // so the property is removed (null) instead of a stray "undefined" key
    // being written on the order while the stone stays on it.
    const key = item.dataset.key || this.stoneKey();
    const value = item.dataset.key ? item.dataset.value : null;

    this.newPersonalizer.dispatchEvent(new CustomEvent("updateExtraCartItem", {
      detail: {},
    }));

    if (!key) return;
    const properties = {
      [key]: value,
    }

    this.newPersonalizer.dispatchEvent(new CustomEvent("updateProperties", {
      detail: {
        properties,
        productHandle: this.productHandle,
      },
    }));
  }
}

customElements.define("new-extra-stone", NewExtraBirthstone);

function formatMoney(cents, formatString = Shopify.money_format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    const parts = number.split("."),
      dollars = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      ),
      cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value);
}

class NewExtraWrapper extends HTMLElement {
  constructor() {
    super();

    this.extraImageEl = this.querySelector(".js-extra-image");

    this.addEventListeners();
  }

  addEventListeners() {
    document.addEventListener("changePreview", (e) => {
      this.handleChangePreview(e.detail.number);
    });
  }

  handleChangePreview(number) {
    if (!this.extraImageEl) return;

    const preview = this.extraImageEl.dataset[`preview-${number}`];
    if (preview) {
      this.extraImageEl.src = preview;
    }
  }
}

customElements.define("new-extra-wrapper", NewExtraWrapper);
